declare var h5: any;
h5 = h5 || {};
h5.autodeploy = {
   angularModule: angular.module("com.vmware.vsphere.client.autodeploy", [])
};

